import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { CircularProgress, Paper } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { getPostsBySearch } from "../../actions/posts"
import ChipInput from "material-ui-chip-input"
import { Link } from "react-router-dom"
import { Button } from '@material-ui/core';
import React, { useEffect, useState } from 'react'
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ReplayIcon from '@material-ui/icons/Replay';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch, useSelector } from 'react-redux';
import useStyles from "./styles"
import Lang from "../../Lang"
import cleanText from '../../utils/cleanText';
import { fetchFeed } from '../../api';

function Main({ text, setText, onRestart, index, setIndex, link, setLink, origen, setOrigen }) {

    const classes = useStyles()
    const user = JSON.parse(localStorage.getItem("profile"))
    let scores = useSelector((state) => state.scores)
    const [tags, setTags] = useState([])
    const [textLenght, setTextLength] = useState(0)
    const [origenCount, setOrigenCount] = useState(0)
    const [selected, setSelected] = useState(false)
    const dispatch = useDispatch()

    const notify = (message) => toast.info(<>{message}<Button component={Link} to={user ? "/Preferences" : "Auth"}><VisibilityIcon className={classes.visibility_icon} /></Button></>, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
    })

    const posts = useSelector((state) => state.posts)


    const [arr, setArr] = useState([])

    let array = []

    const data2 = []
    const data3 = []

    posts.myPosts?.forEach(ele => {
        data2.push({ label: ele.title, value: ele.value })
    })
    posts.posts.forEach(ele => {
        data3.push({ label: ele.title, value: ele.value })
    })

    useEffect(() => {
        setArr([])
        setTextLength(0)
        setOrigenCount(0)
        if (tags.length) {
            dispatch(getPostsBySearch({ tags: tags.join(",") }))
        }
    }, [tags])

    useEffect(() => {
        if (tags.length) {
            for (let i = 0; i < data3.length; i++) {
                getAllText(data3[i].value, data3[i].label)
            }
            onRestart()
            setIndex(1)
        }
    }, [posts.posts])

    useEffect(() => {
        setText(arr[index]?.label)
        setOrigen(arr[index]?.origen)
        setLink(arr[index]?.value)
    }, [index, arr])

    const shuffleArray = (array) => {
        for (var i = array.length - 1; i > 0; i--) {
            var j = Math.floor(Math.random() * (i + 1));
            var temp = array[i];
            array[i] = array[j];
            array[j] = temp;
        }
        return (array)
    }

    const getText = async (u, origen) => {
        let feed = await fetchFeed(u)
        setTextLength(1)
        setTextLength(feed.data.items.length)
        feed.data.items.forEach(item => {
            array.push({ label: cleanText(item.title), value: item.link, origen: origen })
            if (feed.data.items.length === array.length) { setArr(array) }
        });
    }

    const getAllText = async (u, origen) => {
        let feed = await fetchFeed(u)
        let i = 0
        setTextLength(textLenght => textLenght + feed.data.items.length)
        feed.data.items.forEach(item => {
            i++
            array.push({ label: cleanText(item.title), value: item.link, origen: origen })
            if (i === feed.data.items.length) { setArr(arr => arr.concat(shuffleArray(array))); setOrigenCount(origenCount => origenCount + 1) }
        });
    }

    const handleOrigenChangeWithCards = item => {
        setSelected(true)
        setTags([])
        onRestart()
        setOrigen(item.value)
        getText(item.value, item.label)
        setIndex(1)
    }

    const uploadReady = (tag) => {
        const map = {
            '-': ' ',
            '-': '_',
            'a': 'á|à|ã|â|ä|À|Á|Ã|Â|Ä',
            'e': 'é|è|ê|ë|É|È|Ê|Ë',
            'i': 'í|ì|î|ï|Í|Ì|Î|Ï',
            'o': 'ó|ò|ô|õ|ö|Ó|Ò|Ô|Õ|Ö',
            'u': 'ú|ù|û|ü|Ú|Ù|Û|Ü',
            'c': 'ç|Ç',
            '': '´'
        };

        for (var pattern in map) {
            tag = tag.replace(new RegExp(map[pattern], 'g'), pattern);
        }
        tag = tag.toLowerCase()
        tag = tag.charAt(0).toUpperCase() + tag.slice(1)
        return tag;
    }

    return (
        <div className={classes.main_section}>
            <ToastContainer />
            <div className={classes.card_selection} scrollLeft={200} >
                {data2.map(item => (
                    <Paper
                        elevation={item.label === origen ? 5 : 1}
                        style={{ backgroundColor: item.label === origen && "#E9FAF8" }}
                        onClick={() => handleOrigenChangeWithCards(item)}
                        className={classes.card_to_select}>
                        {item.label}
                    </Paper>
                ))}
            </div>
            <div className={classes.row_1}>
                {data2.length !== 0 ? <>
                    {scores?.myScores?.userStatus > 0 ?
                        <ChipInput disabled={!user} className={classes.practice_tag} name="search" variant="outlined" label={<Lang props={"Buscar por tag: Youtube..."} />} value={tags} onAdd={(chip) => setTags([...tags, uploadReady(chip)])} onDelete={(chip) => setTags(tags.filter((tag) => tag !== chip))} />
                        :
                        <ChipInput onClick={() => notify(<Lang props={"Necesitas una cuenta mejor!"} />)} disabled={true} className={classes.practice_tag} name="search" variant="outlined" label={<Lang props={"Buscar por tag: Youtube..."} />} />
                    }
                </> : <h2><Lang props={"¡Necesitas cartas!"} /><ArrowUpwardIcon className={classes.need_to_add_news_arrow} /></h2>}
            </div>
            {data2.length !== 0 && <>
                <div className={classes.row_2}>
                    <Button href={link} target="_blank" disabled={!origen}><VisibilityIcon /></Button>
                    <Button disabled={index === 1} onClick={() => { if (index > 1) { setIndex(index - 1) } }}>
                        <ArrowBackIcon />
                    </Button>
                    {textLenght && tags.length ? <>{+ index + "/" + (origenCount === data3.length ? arr.length - 1 : "...")}</> : tags.length ? <Lang props={"Sin resultados! El tag debe existir"} /> : null}
                    {!tags.length && text && selected ? (<>{+ index + "/" + (arr.length - 1)}</>) : selected && !tags.length ? <CircularProgress /> : null}
                    <Button disabled={index === arr?.length - 1 || !arr.length} onClick={() => { if (index < arr?.length - 1) { setIndex(index + 1) } }}>
                        <ArrowForwardIcon />
                    </Button>
                    <Button onClick={onRestart} disabled={!origen}>
                        <ReplayIcon />
                    </Button>
                </div>
            </>}
        </div>
    )
}

export default Main
